import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import API from '../services/api';

const PERIODOS = [
  { value: 'dia', label: 'Hoy' },
  { value: 'semana', label: 'Esta semana' },
  { value: 'mes', label: 'Este mes' },
  { value: 'año', label: 'Este año' },
  { value: 'todo', label: 'Todos' },
  { value: 'rango', label: 'Rango' },
];

function filtrarPorPeriodo(fichajes, periodo) {
  const ahora = new Date();
  return fichajes.filter(f => {
    const fecha = new Date(f.entrada);
    if (periodo === 'dia') return fecha.toDateString() === ahora.toDateString();
    if (periodo === 'semana') {
      const lunes = new Date(ahora); lunes.setDate(ahora.getDate() - ahora.getDay() + 1); lunes.setHours(0,0,0,0);
      return fecha >= lunes;
    }
    if (periodo === 'mes') return fecha.getMonth() === ahora.getMonth() && fecha.getFullYear() === ahora.getFullYear();
    if (periodo === 'año') return fecha.getFullYear() === ahora.getFullYear();
    return true;
  });
}


function TablaFichajes({ fichajes, nombreEmpleado, navigate, usuario, fmtFecha, fmtHora, duracion, setModalAnular, setMotivoAnular, setError, abrirEditar, s, ocultarEmpleado, ocultarFecha }) {
  const [sortCol, setSortCol] = React.useState('entrada');
  const [sortDir, setSortDir] = React.useState('desc');
  const toggleSort = (col) => {
    if (sortCol === col) setSortDir(d => d === 'asc' ? 'desc' : 'asc');
    else { setSortCol(col); setSortDir('asc'); }
  };
  const fichajesOrdenados = [...fichajes].sort((a, b) => {
    let va = a[sortCol] ?? ''; let vb = b[sortCol] ?? '';
    if (typeof va === 'string') va = va.toLowerCase();
    if (typeof vb === 'string') vb = vb.toLowerCase();
    if (va < vb) return sortDir === 'asc' ? -1 : 1;
    if (va > vb) return sortDir === 'asc' ? 1 : -1;
    return 0;
  });
  const SortTh = ({col, label}) => (
    <th style={{...s.th, cursor:'pointer', userSelect:'none', whiteSpace:'nowrap'}} onClick={() => toggleSort(col)}>
      {label} {sortCol === col ? (sortDir === 'asc' ? '↑' : '↓') : <span style={{color:'#ddd'}}>↕</span>}
    </th>
  );
  return (
    <div style={s.card}>
      <table style={s.table}>
        <thead>
          <tr>
            {!ocultarEmpleado && <SortTh col="empleado_nombre" label="Empleado" />}
            {!ocultarFecha && <SortTh col="entrada" label="Fecha" />}
            <SortTh col="entrada" label="Entrada" />
            <SortTh col="salida" label="Salida" />
            <th style={s.th}>Duración</th>
            <th style={s.th}>Registrado por</th>
            {usuario?.rol === 'admin' && <th style={s.th}>Acciones</th>}
          </tr>
        </thead>
        <tbody>
          {fichajesOrdenados.map(f => (
            <tr key={f.id} style={{...s.tr, ...(f.anulado ? s.trAnulado : {})}} onClick={() => navigate(`/fichajes/${f.id}`)}>
              {!ocultarEmpleado && <td style={s.td}><span style={s.empNombre}>{nombreEmpleado(f.empleado_id)}</span></td>}
              {!ocultarFecha && <td style={s.td}><span style={s.muted}>{fmtFecha(f.entrada)}</span></td>}
              <td style={s.td}>{fmtHora(f.entrada)}</td>
              <td style={s.td}>{f.salida ? fmtHora(f.salida) : <span style={s.pillActivo}>En curso</span>}</td>
              <td style={s.td}>{duracion(f.entrada, f.salida)}</td>
              <td style={s.td}><span style={s.muted}>{f.usuario_id === f.empleado_id ? nombreEmpleado(f.empleado_id) : 'Admin'}</span></td>
              {usuario?.rol === 'admin' && (
                <td style={s.td} onClick={e => e.stopPropagation()}>
                  {!f.anulado && <>
                    <button style={s.btnSmall} onClick={() => abrirEditar(f)}>Editar</button>
                    <button style={{...s.btnSmall, ...s.btnDanger}} onClick={() => { setModalAnular(f); setMotivoAnular(''); setError(''); }}>Anular</button>
                  </>}
                  {f.anulado && <span style={s.pillAnulado}>Anulado</span>}
                </td>
              )}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

function GanttFichajes({ fichajesFiltrados, empleados, fmtHora, duracion, navigate, s }) {
  const hoy = new Date();
  const fmtISO = (d) => d.toISOString().split('T')[0];
  const [modo, setModo] = React.useState('dia');
  const [fechaBase, setFechaBase] = React.useState(fmtISO(hoy));
  const [tooltip, setTooltip] = React.useState(null);

  const getRango = () => {
    const base = new Date(fechaBase + 'T00:00:00');
    if (modo === 'dia') return [fmtISO(base)];
    if (modo === 'semana') {
      const lunes = new Date(base);
      lunes.setDate(base.getDate() - ((base.getDay()+6)%7));
      return Array.from({length:7}, (_,i) => { const d=new Date(lunes); d.setDate(lunes.getDate()+i); return fmtISO(d); });
    }
    if (modo === 'mes') {
      const year = base.getFullYear(), month = base.getMonth();
      const dias = new Date(year, month+1, 0).getDate();
      return Array.from({length:dias}, (_,i) => { const d=new Date(year,month,i+1); return fmtISO(d); });
    }
    return [fmtISO(base)];
  };

  const mover = (dir) => {
    const base = new Date(fechaBase + 'T00:00:00');
    if (modo === 'dia') base.setDate(base.getDate() + dir);
    else if (modo === 'semana') base.setDate(base.getDate() + dir*7);
    else if (modo === 'mes') base.setMonth(base.getMonth() + dir);
    setFechaBase(fmtISO(base));
  };

  const rango = getRango();

  // Agrupar fichajes por día y empleado
  const porDia = {};
  rango.forEach(d => { porDia[d] = {}; });
  fichajesFiltrados.forEach(f => {
    const dia = new Date(f.entrada).toISOString().split('T')[0];
    if (!porDia[dia]) return;
    if (!porDia[dia][f.empleado_id]) porDia[dia][f.empleado_id] = [];
    porDia[dia][f.empleado_id].push(f);
  });

  const empConFichajes = empleados.filter(emp => rango.some(d => porDia[d][emp.id]?.length > 0));

  // Rango de horas fijo 6-22 o dinámico
  const todasHoras = fichajesFiltrados.filter(f => rango.includes(f.entrada?.split('T')[0])).flatMap(f => {
    const h = [new Date(f.entrada).getHours() + new Date(f.entrada).getMinutes()/60];
    if (f.salida) h.push(new Date(f.salida).getHours() + new Date(f.salida).getMinutes()/60);
    return h;
  });
  const horaMin = todasHoras.length ? Math.max(0, Math.floor(Math.min(...todasHoras)) - 0.5) : 6;
  const horaMax = todasHoras.length ? Math.min(24, Math.ceil(Math.max(...todasHoras)) + 0.5) : 22;
  const rangoH = horaMax - horaMin;
  const pct = (h) => ((h - horaMin) / rangoH) * 100;
  const horaDecimal = (iso) => { const d=new Date(iso); return d.getHours()+d.getMinutes()/60+d.getSeconds()/3600; };

  const colors = ['#E6F1FB','#EAF3DE','#F5EFD6','#F0E6F6','#FCE8E8','#E6F6F0'];
  const textColors = ['#185FA5','#3B6D11','#8B6914','#6B3FA0','#A32D2D','#1A7A55'];
  const empIdx = {};
  empleados.forEach((e,i) => { empIdx[e.id] = i; });
  const initials = (n) => n?.split(' ').map(x=>x[0]).slice(0,2).join('').toUpperCase()||'?';
  const horasHeader = Array.from({length: Math.floor(horaMax)-Math.ceil(horaMin)+1}, (_,i) => Math.ceil(horaMin)+i);

  const totalFichajes = rango.reduce((acc,d) => acc + Object.values(porDia[d]).flat().length, 0);

  const fmtDia = (iso) => {
    const d = new Date(iso+'T00:00:00');
    return d.toLocaleDateString('es-ES',{weekday:'short',day:'numeric',month:'short'});
  };

  return (
    <div style={{background:'white',border:'0.5px solid #e0e0d8',borderRadius:12,overflow:'hidden'}}>
      {/* Controles */}
      <div style={{padding:'12px 16px',borderBottom:'0.5px solid #f0f0ed',display:'flex',alignItems:'center',gap:8,flexWrap:'wrap'}}>
        <button onClick={()=>mover(-1)} style={btnStyle}>←</button>
        <button onClick={()=>mover(1)} style={btnStyle}>→</button>
        <input type="date" value={fechaBase} onChange={e=>setFechaBase(e.target.value)} style={{border:'0.5px solid #d0d0c8',borderRadius:8,padding:'5px 10px',fontSize:13,outline:'none'}} />
        {[
          {label:'Hoy', fn:()=>{setModo('dia');setFechaBase(fmtISO(new Date()));}},
          {label:'Semana', fn:()=>{setModo('semana');setFechaBase(fmtISO(new Date()));}},
          {label:'Mes', fn:()=>{setModo('mes');setFechaBase(fmtISO(new Date()));}},
        ].map(b => (
          <button key={b.label} onClick={b.fn} style={{...btnStyle, background: (modo==='dia'&&b.label==='Hoy')||(modo==='semana'&&b.label==='Semana')||(modo==='mes'&&b.label==='Mes') ? '#1a1a1a' : 'white', color: (modo==='dia'&&b.label==='Hoy')||(modo==='semana'&&b.label==='Semana')||(modo==='mes'&&b.label==='Mes') ? 'white' : '#666'}}>{b.label}</button>
        ))}
        <span style={{fontSize:13,color:'#888',marginLeft:4}}>{totalFichajes} fichajes · {empConFichajes.length} empleados</span>
      </div>

      {empConFichajes.length === 0 ? (
        <div style={{padding:48,textAlign:'center',color:'#aaa',fontSize:14}}>No hay fichajes en este periodo</div>
      ) : (
        <div style={{overflowX:'auto'}}>
          <div style={{minWidth:600}}>
            {/* Vista día — una fila por empleado */}
            {modo === 'dia' && <>
              <div style={{display:'flex',borderBottom:'0.5px solid #f0f0ed',paddingLeft:160}}>
                {horasHeader.map(h => (
                  <div key={h} style={{flex:1,fontSize:10,color:'#aaa',padding:'4px 2px',borderLeft:'0.5px solid #f5f5f3'}}>{String(h).padStart(2,'0')}:00</div>
                ))}
              </div>
              {empConFichajes.map(emp => {
                const idx = empIdx[emp.id]%colors.length;
                const fichEmp = porDia[rango[0]][emp.id]||[];
                return (
                  <div key={emp.id} style={{display:'flex',alignItems:'center',borderBottom:'0.5px solid #f5f5f3',minHeight:44}}>
                    <div style={{width:160,flexShrink:0,padding:'0 12px',display:'flex',alignItems:'center',gap:8}}>
                      <div style={{width:24,height:24,borderRadius:'50%',background:colors[idx],color:textColors[idx],display:'flex',alignItems:'center',justifyContent:'center',fontSize:9,fontWeight:600,flexShrink:0}}>{initials(emp.nombre)}</div>
                      <span style={{fontSize:12,fontWeight:500,color:'#1a1a1a',overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{emp.nombre}</span>
                    </div>
                    <div style={{flex:1,position:'relative',height:44}} onMouseLeave={()=>setTooltip(null)}>
                      {horasHeader.map(h=><div key={h} style={{position:'absolute',left:pct(h)+'%',top:0,bottom:0,width:'0.5px',background:'#f0f0ed'}}/>)}
                      {fichEmp.map(f=>{
                        const ini=horaDecimal(f.entrada);
                        const fin=f.salida?horaDecimal(f.salida):horaDecimal(new Date().toISOString());
                        const left=Math.max(0,pct(ini));
                        const width=Math.min(100-left,pct(fin)-pct(ini));
                        return <div key={f.id} onClick={()=>navigate('/fichajes/'+f.id)}
                          onMouseEnter={e=>setTooltip({x:e.clientX,y:e.clientY,text:fmtHora(f.entrada)+' → '+(f.salida?fmtHora(f.salida):'En curso')+' · '+duracion(f.entrada,f.salida)})}
                          style={{position:'absolute',left:left+'%',width:Math.max(width,0.5)+'%',top:'20%',height:'60%',background:f.salida?'#9db8d4':'#34d399',borderRadius:4,display:'flex',alignItems:'center',paddingLeft:4,overflow:'hidden',fontSize:9,color:'#fff',fontWeight:500,boxShadow:'0 1px 3px rgba(0,0,0,0.1)',cursor:'pointer'}}>
                          {width>8&&<span style={{whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis'}}>{duracion(f.entrada,f.salida)}</span>}
                        </div>;
                      })}
                    </div>
                  </div>
                );
              })}
            </>}

            {/* Vista semana/mes — una fila por día, columnas = empleados */}
            {(modo === 'semana' || modo === 'mes') && <>
              {/* Header empleados */}
              <div style={{display:'flex',borderBottom:'0.5px solid #f0f0ed'}}>
                <div style={{width:100,flexShrink:0,padding:'6px 8px',fontSize:10,color:'#aaa',fontWeight:500}}>DÍA</div>
                {empConFichajes.map(emp => (
                  <div key={emp.id} style={{flex:1,padding:'6px 4px',fontSize:10,color:'#555',fontWeight:500,textAlign:'center',overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap',minWidth:0}}>
                    {emp.nombre.split(' ')[0]}
                  </div>
                ))}
              </div>
              {/* Filas días */}
              {rango.map(dia => {
                const tieneFichajes = empConFichajes.some(emp => porDia[dia][emp.id]?.length > 0);
                const esHoy = dia === fmtISO(new Date());
                return (
                  <div key={dia} style={{display:'flex',alignItems:'center',borderBottom:'0.5px solid #f5f5f3',minHeight:36,background:esHoy?'#fafff8':'white'}}>
                    <div style={{width:100,flexShrink:0,padding:'4px 8px',fontSize:11,color:esHoy?'#3B6D11':'#888',fontWeight:esHoy?600:400}}>{fmtDia(dia)}</div>
                    {empConFichajes.map(emp => {
                      const idx = empIdx[emp.id]%colors.length;
                      const fichs = porDia[dia][emp.id]||[];
                      const totalH = fichs.reduce((acc,f)=>{
                        if(!f.salida) return acc;
                        return acc + (new Date(f.salida)-new Date(f.entrada))/3600000;
                      },0);
                      return (
                        <div key={emp.id} style={{flex:1,padding:'3px 4px',textAlign:'center',minWidth:0}}>
                          {fichs.length > 0 ? (
                            <div style={{background:fichs.some(f=>!f.salida)?'#34d399':colors[idx],color:fichs.some(f=>!f.salida)?'white':textColors[idx],borderRadius:4,padding:'2px 4px',fontSize:10,fontWeight:600,cursor:'pointer'}}
                              onClick={()=>fichs.length===1&&navigate('/fichajes/'+fichs[0].id)}>
                              {totalH>0?totalH.toFixed(1)+'h':fichs.some(f=>!f.salida)?'↑':'?'}
                            </div>
                          ) : (
                            <div style={{color:'#f0f0ed',fontSize:16}}>·</div>
                          )}
                        </div>
                      );
                    })}
                  </div>
                );
              })}
            </>}
          </div>
        </div>
      )}

      {tooltip && (
        <div style={{position:'fixed',left:tooltip.x+12,top:tooltip.y-30,background:'#1a1a1a',color:'white',padding:'4px 10px',borderRadius:6,fontSize:12,pointerEvents:'none',zIndex:9999,whiteSpace:'nowrap'}}>
          {tooltip.text}
        </div>
      )}
    </div>
  );
}

const btnStyle = {background:'white',border:'0.5px solid #d0d0c8',borderRadius:8,padding:'5px 10px',fontSize:13,cursor:'pointer',color:'#666'};

export default function Fichajes() {
  const { usuario } = useAuth();
  const navigate = useNavigate();
  const [fichajes, setFichajes] = useState([]);
  const [empleados, setEmpleados] = useState([]);
  const [cargando, setCargando] = useState(true);
  const [modal, setModal] = useState(false);
  const [modalDetalle, setModalDetalle] = useState(null);
  const [logFichaje, setLogFichaje] = useState([]);
  const [modalAnular, setModalAnular] = useState(null);
  const [editando, setEditando] = useState(null);
  const [motivoEdicion, setMotivoEdicion] = useState('');
  const [form, setForm] = useState({ empleado_id: '', fecha_entrada: '', hora_entrada: '', hora_salida: '', notas: '' });
  const [error, setError] = useState('');
  const [filtroEmpleado, setFiltroEmpleado] = useState('');
  const [agrupacion, setAgrupacion] = useState('lista');
  const [rangoDesde, setRangoDesde] = useState('');
  const [rangoHasta, setRangoHasta] = useState('');
  const [periodo, setPeriodo] = useState('mes');
  const [motivoAnular, setMotivoAnular] = useState('');

  useEffect(() => { cargar(); }, []);

  const cargar = async () => {
    try {
      const [fRes, eRes] = await Promise.all([API.get('/fichajes'), API.get('/empleados')]);
      setFichajes(fRes.data);
      setEmpleados(eRes.data);
    } catch(e) {}
    setCargando(false);
  };

  const abrirNuevo = () => {
    const hoy = new Date().toISOString().split('T')[0];
    setEditando(null);
    setMotivoEdicion('');
    setForm({ empleado_id: '', fecha_entrada: hoy, hora_entrada: '09:00', hora_salida: '17:00', notas: '' });
    setError('');
    setModal(true);
  };

  const abrirEditar = (f) => {
    const entrada = new Date(f.entrada);
    const salida = f.salida ? new Date(f.salida) : null;
    setEditando(f);
    setMotivoEdicion('');
    setForm({
      empleado_id: f.empleado_id,
      fecha_entrada: entrada.toISOString().split('T')[0],
      hora_entrada: entrada.toTimeString().slice(0,5),
      hora_salida: salida ? salida.toTimeString().slice(0,5) : '',
      notas: f.notas || '',
    });
    setError('');
    setModal(true);
  };

  const guardar = async () => {
    setError('');
    if (!form.empleado_id || !form.fecha_entrada || !form.hora_entrada) { setError('Empleado, fecha y hora de entrada son obligatorios'); return; }
    if (editando && !motivoEdicion.trim()) { setError('Debes indicar el motivo de la modificación'); return; }
    try {
      const entrada = `${form.fecha_entrada}T${form.hora_entrada}:00`;
      const salida = form.hora_salida ? `${form.fecha_entrada}T${form.hora_salida}:00` : null;
      const payload = { empleado_id: parseInt(form.empleado_id), entrada, salida, notas: form.notas || null, motivo_modificacion: motivoEdicion || null };
      if (editando) {
        await API.put(`/fichajes/${editando.id}`, payload);
      } else {
        await API.post('/fichajes/manual', payload);
      }
      setModal(false);
      cargar();
    } catch(e) { setError(e.response?.data?.detail || 'Error al guardar'); }
  };

  const anular = async () => {
    if (!motivoAnular.trim()) { setError('El motivo es obligatorio'); return; }
    try {
      await API.put(`/fichajes/${modalAnular.id}`, { ...modalAnular, anulado: true, motivo_modificacion: motivoAnular });
      setModalAnular(null);
      setMotivoAnular('');
      cargar();
    } catch(e) {}
  };

  const exportar = async (formato, soloFiltrados) => {
    const datos = soloFiltrados ? fichajesFiltrados : fichajesFiltrados;
    const ahora = new Date();
    const timestamp = ahora.toISOString().replace(/[:.]/g,'-').slice(0,16);
    const periodoLabel = periodo === 'rango'
      ? (rangoDesde && rangoHasta ? `${rangoDesde}_${rangoHasta}` : 'rango')
      : PERIODOS.find(p=>p.value===periodo)?.label || periodo;

    const totalMins = datos.filter(f=>f.salida&&!f.anulado).reduce((acc,f)=>{
      return acc + Math.round((new Date(f.salida)-new Date(f.entrada))/60000);
    }, 0);
    const totalH = Math.floor(totalMins/60);
    const totalM = totalMins % 60;
    const totalStr = `${totalH}h ${totalM > 0 ? totalM+'m' : ''}`.trim();

    if (formato === 'excel') {
      const rows = [['Empleado','Fecha','Entrada','Salida','Duración','Notas','Anulado']];
      datos.forEach(f => {
        rows.push([
          nombreEmpleado(f.empleado_id),
          fmtFecha(f.entrada),
          fmtHora(f.entrada),
          f.salida ? fmtHora(f.salida) : '',
          duracion(f.entrada, f.salida),
          f.notas || '',
          f.anulado ? 'Sí' : 'No'
        ]);
      });
      rows.push([]);
      rows.push(['TOTAL HORAS', '', '', '', totalStr, '', '']);
      const csv = rows.map(r => r.map(c => `"${c}"`).join(',')).join('\n');
      const blob = new Blob(['\uFEFF' + csv], { type: 'text/csv;charset=utf-8;' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `fichajes_${periodoLabel}_${timestamp}.csv`;
      a.click();
    } else {
      const win = window.open('', '_blank');
      win.document.write(`<!DOCTYPE html><html><head><title>Fichajes</title><style>
        body{font-family:Arial,sans-serif;font-size:12px;margin:24px;color:#1a1a1a}
        h1{font-size:18px;margin-bottom:4px}
        .meta{color:#888;font-size:11px;margin-bottom:20px}
        table{width:100%;border-collapse:collapse;margin-bottom:20px}
        th{background:#f5f5f5;padding:8px;text-align:left;font-size:11px;text-transform:uppercase;letter-spacing:0.05em;border-bottom:2px solid #ddd}
        td{padding:8px;border-bottom:1px solid #eee;font-size:12px}
        .anulado{text-decoration:line-through;color:#aaa}
        .resumen{background:#f5f5f5;border-radius:8px;padding:16px;margin-top:16px}
        .resumen h3{margin:0 0 8px 0;font-size:13px}
        .resumen .total{font-size:22px;font-weight:bold;color:#378ADD}
        @media print{body{margin:0}}
      </style></head><body>`);
      win.document.write(`<h1>Registro de fichajes</h1>`);
      win.document.write(`<div class="meta">Periodo: ${periodoLabel} &nbsp;|&nbsp; Exportado el ${ahora.toLocaleString('es-ES')} &nbsp;|&nbsp; ${datos.filter(f=>!f.anulado).length} fichajes</div>`);
      win.document.write(`<table><tr><th>Empleado</th><th>Fecha</th><th>Entrada</th><th>Salida</th><th>Duración</th><th>Notas</th></tr>`);
      datos.forEach(f => {
        win.document.write(`<tr class="${f.anulado?'anulado':''}"><td>${nombreEmpleado(f.empleado_id)}</td><td>${fmtFecha(f.entrada)}</td><td>${fmtHora(f.entrada)}</td><td>${f.salida?fmtHora(f.salida):'—'}</td><td>${duracion(f.entrada,f.salida)}</td><td>${f.notas||''}</td></tr>`);
      });
      win.document.write(`</table>`);
      win.document.write(`<div class="resumen"><h3>Resumen del periodo</h3><div class="total">${totalStr}</div><div style="font-size:11px;color:#888;margin-top:4px">horas trabajadas (excluye fichajes anulados)</div></div>`);
      win.document.write(`</body></html>`);
      win.document.close();
      // sin autoimpresión
    }
  };

  const [modalExportar, setModalExportar] = useState(false);
  const [exportFormato, setExportFormato] = useState('pdf');
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  useEffect(() => {
    const h = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', h);
    return () => window.removeEventListener('resize', h);
  }, []);

  const duracion = (entrada, salida) => {
    if (!salida) return '—';
    const mins = Math.round((new Date(salida) - new Date(entrada)) / 60000);
    const h = Math.floor(mins / 60); const m = mins % 60;
    return `${h}h${m > 0 ? ' ' + m + 'm' : ''}`;
  };
  const fmtFecha = (iso) => iso ? new Date(iso).toLocaleDateString('es-ES', {day:'2-digit',month:'2-digit',year:'numeric'}) : '—';
  const fmtHora = (iso) => iso ? new Date(iso).toLocaleTimeString('es-ES', {hour:'2-digit',minute:'2-digit'}) : '—';
  const fmtDatetime = (iso) => iso ? new Date(iso).toLocaleString('es-ES', {day:'2-digit',month:'2-digit',year:'numeric',hour:'2-digit',minute:'2-digit'}) : '—';
  const nombreEmpleado = (id) => empleados.find(e => e.id === id)?.nombre || '—';

  const fichajesFiltrados = (() => {
    let base = filtroEmpleado ? fichajes.filter(f => f.empleado_id === parseInt(filtroEmpleado)) : fichajes;
    if (periodo === 'rango') {
      return base.filter(f => {
        const fecha = new Date(f.entrada);
        const desde = rangoDesde ? new Date(rangoDesde) : null;
        const hasta = rangoHasta ? new Date(rangoHasta + 'T23:59:59') : null;
        if (desde && fecha < desde) return false;
        if (hasta && fecha > hasta) return false;
        return true;
      });
    }
    return filtrarPorPeriodo(base, periodo);
  })();


  if (cargando) return <div style={s.loading}>Cargando...</div>;

  return (
    <div style={s.page}>
      <div style={s.topbar}>
        <div style={s.topbarTitle}>Fichajes</div>
        <div style={s.topbarActions}>
          <div style={s.periodos}>
            {PERIODOS.map(p => (
              <button key={p.value} style={{...s.periodoBtn, ...(periodo === p.value ? s.periodoBtnActive : {})}} onClick={() => setPeriodo(p.value)}>{p.label}</button>
            ))}
          </div>
          {periodo === 'rango' && (
            <div style={{display:'flex', gap:6, alignItems:'center'}}>
              <input type="date" style={s.inputFecha} value={rangoDesde} onChange={e => setRangoDesde(e.target.value)} />
              <span style={{color:'#aaa',fontSize:12}}>→</span>
              <input type="date" style={s.inputFecha} value={rangoHasta} onChange={e => setRangoHasta(e.target.value)} />
            </div>
          )}
          <div style={{display:'flex',gap:4,marginRight:8}}>
            {['lista','gantt'].map(v => (
              <button key={v} onClick={()=>setAgrupacion(v)} style={{
                background: agrupacion===v ? '#1a1a1a' : 'white',
                color: agrupacion===v ? 'white' : '#666',
                border:'0.5px solid #d0d0c8', borderRadius:8,
                padding:'6px 14px', fontSize:12, cursor:'pointer', fontWeight:500,
                textTransform:'capitalize'
              }}>{v === 'lista' ? '☰ Lista' : '▬ Gantt'}</button>
            ))}
          </div>
          <select style={s.select} value={agrupacion === 'gantt' ? 'lista' : agrupacion} onChange={e => setAgrupacion(e.target.value)}>
            <option value="lista">Lista</option>
            <option value="empleado">Por empleado</option>
            <option value="dia">Por día</option>
          </select>
          <select style={s.select} value={filtroEmpleado} onChange={e => setFiltroEmpleado(e.target.value)}>
            <option value="">Todos los empleados</option>
            {empleados.map(e => <option key={e.id} value={e.id}>{e.nombre}</option>)}
          </select>
          <button style={s.btnSecondary} onClick={() => setModalExportar(true)}>↓ Exportar</button>
          {usuario?.rol === 'admin' && <button style={s.btn} onClick={abrirNuevo}>+ Añadir fichaje</button>}
        </div>
      </div>

      <div style={s.content}>
        <div style={s.resumen}>
          <div style={s.resumenItem}><span style={s.resumenNum}>{fichajesFiltrados.filter(f=>!f.anulado).length}</span><span style={s.resumenLabel}>Fichajes</span></div>
          <div style={s.resumenItem}><span style={s.resumenNum}>{fichajesFiltrados.filter(f=>f.salida&&!f.anulado).reduce((acc,f)=>{const mins=Math.round((new Date(f.salida)-new Date(f.entrada))/60000);return acc+mins;},0) > 0 ? Math.round(fichajesFiltrados.filter(f=>f.salida&&!f.anulado).reduce((acc,f)=>{return acc+Math.round((new Date(f.salida)-new Date(f.entrada))/60000);},0)/60*10)/10 : 0}h</span><span style={s.resumenLabel}>Horas totales</span></div>
          <div style={s.resumenItem}><span style={s.resumenNum}>{fichajesFiltrados.filter(f=>!f.salida&&!f.anulado).length}</span><span style={s.resumenLabel}>En curso</span></div>
          <div style={s.resumenItem}><span style={s.resumenNum}>{fichajesFiltrados.filter(f=>f.anulado).length}</span><span style={s.resumenLabel}>Anulados</span></div>
        </div>

        {fichajesFiltrados.length === 0 ? (
          <div style={s.empty}><div style={s.emptyText}>No hay fichajes en este periodo</div></div>
        ) : agrupacion === 'lista' ? (
          <TablaFichajes fichajes={fichajesFiltrados} nombreEmpleado={nombreEmpleado} navigate={navigate} usuario={usuario} fmtFecha={fmtFecha} fmtHora={fmtHora} duracion={duracion} setModalAnular={setModalAnular} setMotivoAnular={setMotivoAnular} setError={setError} abrirEditar={abrirEditar} s={s} />
        ) : agrupacion === 'gantt' ? (
          <GanttFichajes fichajesFiltrados={fichajesFiltrados} empleados={empleados} fmtHora={fmtHora} duracion={duracion} navigate={navigate} s={s} />
        ) : agrupacion === 'empleado' ? (
          (() => {
            const grupos = {};
            fichajesFiltrados.forEach(f => {
              const k = f.empleado_id;
              if (!grupos[k]) grupos[k] = [];
              grupos[k].push(f);
            });
            return Object.entries(grupos).map(([empId, fs]) => (
              <div key={empId} style={{marginBottom:16}}>
                <div style={s.grupoHeader}>
                  <span style={s.grupoTitulo}>{nombreEmpleado(parseInt(empId))}</span>
                  <span style={s.grupoMeta}>{fs.filter(f=>!f.anulado).length} fichajes · {(() => { const m = fs.filter(f=>f.salida&&!f.anulado).reduce((a,f)=>a+Math.round((new Date(f.salida)-new Date(f.entrada))/60000),0); return `${Math.floor(m/60)}h${m%60>0?' '+m%60+'m':''}`; })()}</span>
                </div>
                <TablaFichajes fichajes={fs} nombreEmpleado={nombreEmpleado} navigate={navigate} usuario={usuario} fmtFecha={fmtFecha} fmtHora={fmtHora} duracion={duracion} setModalAnular={setModalAnular} setMotivoAnular={setMotivoAnular} setError={setError} abrirEditar={abrirEditar} s={s} ocultarEmpleado />
              </div>
            ));
          })()
        ) : (
          (() => {
            const grupos = {};
            fichajesFiltrados.forEach(f => {
              const k = new Date(f.entrada).toISOString().split('T')[0];
              if (!grupos[k]) grupos[k] = [];
              grupos[k].push(f);
            });
            return Object.entries(grupos).sort((a,b)=>b[0].localeCompare(a[0])).map(([fecha, fs]) => (
              <div key={fecha} style={{marginBottom:16}}>
                <div style={s.grupoHeader}>
                  <span style={s.grupoTitulo}>{new Date(fecha).toLocaleDateString('es-ES',{weekday:'long',day:'numeric',month:'long'})}</span>
                  <span style={s.grupoMeta}>{fs.filter(f=>!f.anulado).length} fichajes · {(() => { const m = fs.filter(f=>f.salida&&!f.anulado).reduce((a,f)=>a+Math.round((new Date(f.salida)-new Date(f.entrada))/60000),0); return `${Math.floor(m/60)}h${m%60>0?' '+m%60+'m':''}`; })()}</span>
                </div>
                <TablaFichajes fichajes={fs} nombreEmpleado={nombreEmpleado} navigate={navigate} usuario={usuario} fmtFecha={fmtFecha} fmtHora={fmtHora} duracion={duracion} setModalAnular={setModalAnular} setMotivoAnular={setMotivoAnular} setError={setError} abrirEditar={abrirEditar} s={s} ocultarFecha />
              </div>
            ));
          })()
        )}
      </div>

      {/* MODAL DETALLE */}
      {modalDetalle && (
        <div style={s.overlay} onClick={() => setModalDetalle(null)}>
          <div style={s.modal} onClick={e => e.stopPropagation()}>
            <div style={s.modalHeader}>
              <div style={s.modalTitle}>Detalle del fichaje</div>
              <button style={s.closeBtn} onClick={() => setModalDetalle(null)}>✕</button>
            </div>
            <div style={s.detalleGrid}>
              <div style={s.detalleRow}><span style={s.detalleLabel}>Empleado</span><span>{nombreEmpleado(modalDetalle.empleado_id)}</span></div>
              <div style={s.detalleRow}><span style={s.detalleLabel}>Entrada</span><span>{fmtDatetime(modalDetalle.entrada)}</span></div>
              <div style={s.detalleRow}><span style={s.detalleLabel}>Salida</span><span>{modalDetalle.salida ? fmtDatetime(modalDetalle.salida) : '— (en curso)'}</span></div>
              <div style={s.detalleRow}><span style={s.detalleLabel}>Duración</span><span>{duracion(modalDetalle.entrada, modalDetalle.salida)}</span></div>
              <div style={s.detalleRow}><span style={s.detalleLabel}>Registrado por</span><span>{modalDetalle.usuario_id === modalDetalle.empleado_id ? nombreEmpleado(modalDetalle.empleado_id) : 'Admin'}</span></div>
              {modalDetalle.notas && <div style={s.detalleRow}><span style={s.detalleLabel}>Notas</span><span>{modalDetalle.notas}</span></div>}
              {modalDetalle.motivo_modificacion && <div style={s.detalleRow}><span style={s.detalleLabel}>Motivo modificación</span><span style={{color:'#e8a838'}}>{modalDetalle.motivo_modificacion}</span></div>}
              {modalDetalle.fecha_modificacion && <div style={s.detalleRow}><span style={s.detalleLabel}>Modificado el</span><span>{fmtDatetime(modalDetalle.fecha_modificacion)}</span></div>}
              {modalDetalle.anulado && <div style={s.detalleRow}><span style={s.detalleLabel}>Estado</span><span style={{color:'#A32D2D',fontWeight:600}}>ANULADO</span></div>}
            </div>
            {logFichaje.length > 0 && (
              <div style={{marginTop:20}}>
                <div style={{fontSize:11,fontWeight:600,color:'#aaa',textTransform:'uppercase',letterSpacing:'0.05em',marginBottom:10}}>Historial de cambios</div>
                {logFichaje.map((log, i) => (
                  <div key={i} style={{display:'flex',gap:10,padding:'8px 0',borderTop:'0.5px solid #f0f0ed',fontSize:12}}>
                    <span style={{color:'#aaa',flexShrink:0,fontFamily:'monospace'}}>{new Date(log.fecha).toLocaleString('es-ES',{day:'2-digit',month:'2-digit',year:'numeric',hour:'2-digit',minute:'2-digit'})}</span>
                    <span style={{color:'#378ADD',flexShrink:0,fontWeight:500}}>{log.usuario}</span>
                    <span style={{color:'#666'}}>{log.accion}{log.detalle ? ` — ${log.detalle}` : ''}</span>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      )}

      {/* MODAL ANULAR */}
      {modalAnular && (
        <div style={s.overlay} onClick={() => setModalAnular(null)}>
          <div style={s.modal} onClick={e => e.stopPropagation()}>
            <div style={s.modalHeader}>
              <div style={s.modalTitle}>Anular fichaje</div>
              <button style={s.closeBtn} onClick={() => setModalAnular(null)}>✕</button>
            </div>
            <p style={{fontSize:13,color:'#666',marginBottom:16}}>El fichaje quedará anulado pero visible en el registro. Esta acción queda registrada.</p>
            {error && <div style={s.errorBox}>{error}</div>}
            <div style={s.field}>
              <label style={s.label}>Motivo de anulación *</label>
              <input style={s.input} value={motivoAnular} onChange={e => setMotivoAnular(e.target.value)} placeholder="Ej: Error de fichaje, duplicado..." />
            </div>
            <div style={s.modalFooter}>
              <button style={s.btnSecondary} onClick={() => setModalAnular(null)}>Cancelar</button>
              <button style={{...s.btn, background:'#A32D2D'}} onClick={anular}>Confirmar anulación</button>
            </div>
          </div>
        </div>
      )}

      {/* MODAL EXPORTAR */}
      {modalExportar && (
        <div style={s.overlay} onClick={() => setModalExportar(false)}>
          <div style={{...s.modal, maxWidth:360}} onClick={e => e.stopPropagation()}>
            <div style={s.modalHeader}>
              <div style={s.modalTitle}>Exportar fichajes</div>
              <button style={s.closeBtn} onClick={() => setModalExportar(false)}>✕</button>
            </div>
            <div style={s.field}>
              <label style={s.label}>Formato</label>
              <div style={{display:'flex',gap:8}}>
                <button style={{...s.btnSecondary, flex:1, ...(exportFormato==='pdf'?{border:'1px solid #378ADD',color:'#378ADD'}:{})}} onClick={() => setExportFormato('pdf')}>PDF</button>
                <button style={{...s.btnSecondary, flex:1, ...(exportFormato==='excel'?{border:'1px solid #378ADD',color:'#378ADD'}:{})}} onClick={() => setExportFormato('excel')}>Excel / CSV</button>
              </div>
            </div>
            <div style={s.modalFooter}>
              <button style={s.btnSecondary} onClick={() => { exportar(exportFormato, false); setModalExportar(false); }}>Todo el periodo</button>
              <button style={s.btn} onClick={() => { exportar(exportFormato, true); setModalExportar(false); }}>Solo filtrados</button>
            </div>
          </div>
        </div>
      )}

      {/* MODAL AÑADIR/EDITAR */}
      {modal && (
        <div style={s.overlay} onClick={() => setModal(false)}>
          <div style={s.modal} onClick={e => e.stopPropagation()}>
            <div style={s.modalHeader}>
              <div style={s.modalTitle}>{editando ? 'Editar fichaje' : 'Añadir fichaje'}</div>
              <button style={s.closeBtn} onClick={() => setModal(false)}>✕</button>
            </div>
            {error && <div style={s.errorBox}>{error}</div>}
            <div style={s.field}>
              <label style={s.label}>Empleado *</label>
              <select style={s.input} value={form.empleado_id} onChange={e => setForm({...form, empleado_id: e.target.value})}>
                <option value="">Selecciona empleado</option>
                {empleados.filter(e => e.activo).map(e => <option key={e.id} value={e.id}>{e.nombre}</option>)}
              </select>
            </div>
            <div style={s.field}>
              <label style={s.label}>Fecha *</label>
              <input style={s.input} type="date" value={form.fecha_entrada} onChange={e => setForm({...form, fecha_entrada: e.target.value})} />
            </div>
            <div style={s.fieldRow}>
              <div style={{...s.field, flex:1}}><label style={s.label}>Hora entrada *</label><input style={s.input} type="time" value={form.hora_entrada} onChange={e => setForm({...form, hora_entrada: e.target.value})} /></div>
              <div style={{...s.field, flex:1}}><label style={s.label}>Hora salida</label><input style={s.input} type="time" value={form.hora_salida} onChange={e => setForm({...form, hora_salida: e.target.value})} /></div>
            </div>
            <div style={s.field}>
              <label style={s.label}>Notas</label>
              <input style={s.input} value={form.notas} onChange={e => setForm({...form, notas: e.target.value})} placeholder="Opcional" />
            </div>
            {editando && (
              <div style={s.field}>
                <label style={s.label}>Motivo de la modificación *</label>
                <input style={s.input} value={motivoEdicion} onChange={e => setMotivoEdicion(e.target.value)} placeholder="Obligatorio por ley (RDL 8/2019)" />
              </div>
            )}
            <div style={s.modalFooter}>
              <button style={s.btnSecondary} onClick={() => setModal(false)}>Cancelar</button>
              <button style={s.btn} onClick={guardar}>{editando ? 'Guardar cambios' : 'Añadir fichaje'}</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

const s = {
  page: { display:'flex', flexDirection:'column', minHeight:'100vh', background:'#f5f5f3', fontFamily:'-apple-system, BlinkMacSystemFont, Inter, sans-serif' },
  loading: { display:'flex', alignItems:'center', justifyContent:'center', height:'100vh', color:'#aaa', fontSize:14 },
  topbar: { background:'white', borderBottom:'0.5px solid #e0e0d8', padding:'12px 16px', minHeight:56, display:'flex', alignItems:'flex-start', justifyContent:'space-between', flexWrap:'wrap', gap:8 },
  topbarTitle: { fontSize:14, fontWeight:500, color:'#1a1a1a' },
  topbarActions: { display:'flex', gap:8, alignItems:'center', flexWrap:'wrap', flex:1, justifyContent:'flex-end' },
  periodos: { display:'flex', background:'#f0f0ed', borderRadius:8, padding:2, gap:2, overflowX:'auto', maxWidth:'100%' },
  periodoBtn: { background:'none', border:'none', borderRadius:6, padding:'4px 10px', fontSize:12, cursor:'pointer', color:'#666' },
  periodoBtnActive: { background:'white', color:'#1a1a1a', fontWeight:500, boxShadow:'0 1px 3px rgba(0,0,0,0.1)' },
  content: { padding:'16px 12px', display:'flex', flexDirection:'column', gap:12 },
  resumen: { display:'grid', gridTemplateColumns:'repeat(auto-fit, minmax(130px, 1fr))', gap:10 },
  resumenItem: { background:'white', border:'0.5px solid #e0e0d8', borderRadius:10, padding:'12px 16px', display:'flex', flexDirection:'column', gap:2 },
  resumenNum: { fontSize:22, fontWeight:600, color:'#1a1a1a' },
  resumenLabel: { fontSize:11, color:'#aaa', textTransform:'uppercase', letterSpacing:'0.05em' },
  card: { background:'white', border:'0.5px solid #e0e0d8', borderRadius:12, overflowX:'auto' },
  table: { width:'100%', borderCollapse:'collapse' },
  th: { padding:'10px 16px', fontSize:11, fontWeight:500, color:'#aaa', textAlign:'left', borderBottom:'0.5px solid #f0f0ed', textTransform:'uppercase', letterSpacing:'0.05em' },
  tr: { borderBottom:'0.5px solid #f0f0ed', cursor:'pointer' },
  trAnulado: { opacity:0.4 },
  td: { padding:'12px 16px', fontSize:13, color:'#1a1a1a', verticalAlign:'middle' },
  empNombre: { fontWeight:500 },
  muted: { color:'#888' },
  pillActivo: { background:'#EAF3DE', color:'#3B6D11', fontSize:11, padding:'2px 8px', borderRadius:10, fontWeight:500 },
  pillAnulado: { background:'#FCEBEB', color:'#A32D2D', fontSize:11, padding:'2px 8px', borderRadius:10 },
  btn: { background:'#378ADD', color:'white', border:'none', borderRadius:8, padding:'8px 14px', fontSize:13, fontWeight:500, cursor:'pointer' },
  btnSmall: { background:'#f0f0ed', color:'#444', border:'none', borderRadius:6, padding:'5px 10px', fontSize:12, cursor:'pointer', marginRight:6 },
  btnDanger: { background:'#FCEBEB', color:'#A32D2D' },
  btnSecondary: { background:'white', color:'#666', border:'0.5px solid #d0d0c8', borderRadius:8, padding:'8px 14px', fontSize:13, cursor:'pointer' },
  select: { padding:'7px 10px', borderRadius:8, border:'0.5px solid #d0d0c8', fontSize:13, background:'white', outline:'none' },
  empty: { textAlign:'center', padding:'64px 0' },
  emptyText: { fontSize:14, color:'#aaa' },
  grupoHeader: { display:'flex', alignItems:'center', justifyContent:'space-between', padding:'8px 4px', marginBottom:4 },
  grupoTitulo: { fontSize:13, fontWeight:600, color:'#1a1a1a' },
  grupoMeta: { fontSize:12, color:'#aaa' },
  inputFecha: { padding:'6px 10px', borderRadius:8, border:'0.5px solid #d0d0c8', fontSize:12, background:'white', outline:'none' },
  overlay: { position:'fixed', inset:0, background:'rgba(0,0,0,0.3)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:1000 },
  modal: { background:'white', borderRadius:12, border:'0.5px solid #e0e0d8', padding:20, width:'calc(100% - 32px)', maxWidth:500, maxHeight:'85vh', overflowY:'auto' },
  modalHeader: { display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:20 },
  modalTitle: { fontSize:15, fontWeight:500, color:'#1a1a1a' },
  closeBtn: { background:'none', border:'none', fontSize:16, cursor:'pointer', color:'#aaa' },
  errorBox: { background:'#FCEBEB', color:'#A32D2D', borderRadius:8, padding:'10px 14px', fontSize:13, marginBottom:16 },
  field: { marginBottom:16 },
  fieldRow: { display:'flex', gap:12 },
  label: { display:'block', fontSize:13, color:'#444', marginBottom:6, fontWeight:500 },
  input: { width:'100%', padding:'9px 12px', borderRadius:8, border:'0.5px solid #d0d0c8', fontSize:14, outline:'none', boxSizing:'border-box', background:'white' },
  modalFooter: { display:'flex', justifyContent:'flex-end', gap:10, marginTop:24 },
  detalleGrid: { display:'flex', flexDirection:'column', gap:0 },
  detalleRow: { display:'flex', justifyContent:'space-between', padding:'10px 0', borderBottom:'0.5px solid #f0f0ed', fontSize:13 },
  detalleLabel: { color:'#888' },
};
